<button
  type="button"
  class="sidebar-nav-group-toggle"
  [class.is-collapsed]="!open()"
  [attr.aria-expanded]="open()"
  [attr.aria-label]="
    (open() ? 'sidebar.collapse_section_aria' : 'sidebar.expand_section_aria')
      | transloco: { name: label() }
  "
  (click)="toggle()"
>
  <mat-icon class="sidebar-nav-group-chevron" aria-hidden="true">expand_more</mat-icon>
  <span class="sidebar-nav-group-label">{{ label() }}</span>
</button>

<div [appCollapsible]="!open()" collapsibleAxis="height">
  <div class="sidebar-nav-group-body">
    <ng-content />
  </div>
</div>
